<template>
    <div id="app" :class="{'theme-dark': isDarkMode}"> 
    <!-- CHAMADA DO TOOLBAR -->    
    <!-- CHAMADA DO TOOLBAR -->
    <v-app>      
      <Toolbar @dark-mode-changed="updateDarkMode" />
        <v-content class="app-content">           
            <!-- CHAMADA DO CONTEUDO -->          
            <Content />                              
        </v-content>
      <!-- CHAMADA DO FOOTER -->
      <Footer />
      <!-- CHAMADA DO FOOTER -->
    </v-app>
</div>
</template>

<script>
    import Footer from '../componentes/footer.vue'
    import Toolbar from '../componentes/toolbar.vue'
    import Content from '../componentes/content.vue'
    import { mapState } from "vuex"
    export default {
    name: 'app',
    components: {Footer, Toolbar, Content},
    data() {
      return {
        isDarkMode: false
      }
    },
    computed: {
       ...mapState({
        usuarioadmin: state => state.Userpermission,
      })
    },
    methods: {
      updateDarkMode(isDark) {
        this.isDarkMode = isDark;
      }
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

:root {
  --primary-color: #6a11cb;
  --primary-gradient: linear-gradient(to right, #6a11cb, #2575fc);
  --secondary-color: #2575fc;
  --background-light: #f8fafc;
  --text-dark: #333333;
  --text-light: #f8fafc;
  --shadow-light: 0 4px 20px rgba(0, 0, 0, 0.08);
  --shadow-dark: 0 4px 20px rgba(0, 0, 0, 0.25);
  --border-radius: 10px;
  --transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {	
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Poppins', sans-serif;
  color: var(--text-dark);
  background: var(--background-light);
  background-image: radial-gradient(#e6e6e6 0.5px, transparent 0.5px), radial-gradient(#e6e6e6 0.5px, var(--background-light) 0.5px);
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
  transition: var(--transition);
}

.theme-dark {
  --background-light: #121212;
  --text-dark: #f8fafc;
  --shadow-light: 0 4px 20px rgba(0, 0, 0, 0.4);
  background-image: radial-gradient(#333 0.5px, transparent 0.5px), radial-gradient(#333 0.5px, var(--background-light) 0.5px);
}

.app-content {
  padding: 0;
  margin: 0;
  transition: var(--transition);
  position: relative;
  top: 0;
  left: 0;
}

.v-application {
  font-family: 'Poppins', sans-serif !important;
}

.v-btn {
  letter-spacing: 0.5px;
  text-transform: none !important;
  font-weight: 500 !important;
  transition: var(--transition);
}

.v-card {
  border-radius: var(--border-radius) !important;
  transition: var(--transition);
  overflow: hidden;
}

.theme-dark .v-card {
  background-color: #1e1e1e !important;
  color: var(--text-light);
}

.v-tabs-bar.v-item-group {
  height: 42px;
  background-color: transparent !important;
  border-radius: var(--border-radius) !important;
}

.v-tab {
  border-radius: var(--border-radius) !important;
  letter-spacing: 0.5px;
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-tab--active {
  background-color: var(--primary-color) !important;
  color: white !important;
  box-shadow: var(--shadow-light);
}

html {
  overflow-y: auto;
}

@media only screen and (max-width: 600px) {
  .app-content {
    padding: 0;
  }
}

/* Animações */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-enter-active {
  animation: fadeIn 0.3s ease-out forwards;
}

.fade-leave-active {
  animation: fadeIn 0.3s ease-in reverse;
}
</style>
